import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/producto/producto';
import ProductoCrear from './ProductoCrear';

const mstp = state => {
    return {...state.productos}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ProductoCrear)
